import Interceptor from "./Interceptor";

// Get Dashboard Analytics
export const getDashboardAnalytics = async () => {
  try {
    const response = await Interceptor.get("/analytics/dashboard");
    return response.data; // { success, data }
  } catch (error) {
    throw error;
  }
};

// Get site specific analytics
export const siteSpecificAnalytics = async ({ siteId, period = "7d" }) => {
  try {
    const response = await Interceptor.get(`/analytics/sites/${siteId}`, {
      params: { period },
    });
    return response.data; // { success, data }
  } catch (error) {
    throw error;
  }
};

// Get paginated activities
export const getPaginatedActivities = async ({
  page = 1,
  limit = 10,
  search = "",
  sortBy = "createdAt",
  order = "desc",
  type = "",
}) => {
  try {
    const response = await Interceptor.get("/analytics/activities", {
      params: { page, limit, search, sortBy, order, type },
    });
    return response.data; // { success, data: { items, pagination } }
  } catch (error) {
    throw error;
  }
};
